
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function ManufacturerBanners() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const manufacturers = [
    {
      name: 'FLEX',
      logo: 'https://shop.flexnet.co.jp/cdn/shop/files/logo.svg?v=1759283241&width=130',
      url: 'https://shop.flexnet.co.jp/'
    },
    {
      name: 'TOPY実業',
      logo: '',
      url: 'https://topyep-apdwheels.com/'
    },
    {
      name: 'アピオ',
      logo: 'https://apio.jp/assets_2015/common/images/header_logo.png',
      url: 'https://apio.jp/'
    },
    {
      name: 'ヴァレンティ',
      logo: 'https://valentijapan.com/wp-content/themes/idolcorp/images/common/logo_wh.svg',
      url: 'https://valentijapan.com/'
    }
  ];

  return (
    <section ref={ref} className="py-20 px-4 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#00d4ff]/5 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            提携メーカー
            <span className="block text-[#00d4ff] text-2xl md:text-3xl mt-2">Partner Manufacturers</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#00d4ff] to-[#39ff14] mx-auto"></div>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {manufacturers.map((manufacturer, index) => (
            <motion.a
              key={manufacturer.name}
              href={manufacturer.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ scale: 1.05, y: -5 }}
              className="group relative bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:border-[#00d4ff]/50 transition-all duration-300 cursor-pointer"
            >
              {/* Glow Effect on Hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#00d4ff]/0 to-[#39ff14]/0 group-hover:from-[#00d4ff]/10 group-hover:to-[#39ff14]/10 rounded-xl transition-all duration-300"></div>
              
              <div className="relative z-10 flex items-center justify-center h-24">
                {manufacturer.logo ? (
                  <img 
                    src={manufacturer.logo} 
                    alt={manufacturer.name}
                    className="max-w-full max-h-full object-contain filter brightness-0 invert group-hover:brightness-100 group-hover:invert-0 transition-all duration-300"
                  />
                ) : (
                  <span className="text-white text-xl font-bold">{manufacturer.name}</span>
                )}
              </div>
              
              {/* Shine Effect */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent transform -skew-x-12 translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-1000"></div>
              </div>
            </motion.a>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="text-center mt-12"
        >
          <p className="text-white/60 text-sm">
            その他多数のメーカー様と提携予定
          </p>
        </motion.div>
      </div>
    </section>
  );
}
